import { loadScriptSync } from '@/utils/utils'
import { delay } from '@/utils/timer'
import omit from 'lodash/omit'

// 身份：gee82c，  场景：h5rhj4j5

window.AliyunCaptchaConfig = {
    region: 'cn',
    prefix: 'gee82c',
}

let captchaPromise = null
let sdkPromise = null

export const loadCaptchaSDK = () => {
    if (window.initAliyunCaptcha) {
        return Promise.resolve()
    }

    if (sdkPromise) {
        return sdkPromise
    }

    sdkPromise = new Promise((resolve, reject) => {
        loadScriptSync('https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js')
            .then(() => delay(3000).then(() => resolve()))
            .catch(e => reject(e))
    })

    return sdkPromise
}

loadCaptchaSDK()

const getCaptcha = options => {
    const createInstance = () => {
        return new Promise((resolve, reject) => {
            options
                ?.getEncryptedSceneId?.()
                ?.then(encryptedId => {
                    window.initAliyunCaptcha({
                        SceneId: 'h5rhj4j5',
                        EncryptedSceneId: encryptedId,
                        mode: 'popup',
                        element: '#captcha-element',
                        button: '#captcha-button',
                        getInstance(instance) {
                            resolve(instance)
                        },
                        ...omit(options, ['getEncryptedSceneId']),
                    })
                })
                ?.catch(e => reject(e))
        })
    }

    if (captchaPromise) {
        return captchaPromise.then(() => createInstance())
    }

    captchaPromise = loadCaptchaSDK().then(() => createInstance())

    return captchaPromise
}

export const openCaptcha = async options => {
    const instance = await getCaptcha(options).catch(() => null)

    if (!instance) {
        const error = new Error('验证码初始化失败，请稍后再试')
        if (options?.onError && typeof onError === 'function') {
            options?.onError(error)
        }
        return Promise.reject(error)
    }

    instance.show()

    setTimeout(() => {
        const aliyunCaptchaMask = document.querySelector('#aliyunCaptcha-mask')

        if (aliyunCaptchaMask) {
            aliyunCaptchaMask.onclick = null
        }
    }, 60)

    // 返回实例以便外部控制
    return instance
}
